<template>
<section class="login-block">
  <div class="container">
	   <div class="row">
    		<div class="col-md-8 banner-sec">
          <div id="carouselExampleIndicators" class="carousel slide" data-ride="carousel">
            <div class="carousel-inner" role="listbox">
              <div class="carousel-item active">
                <div class="logo">
                  <div class="logo-container">
                    <img id="pc-logo" src="https://di-support.com/wp-content/uploads/2018/09/printcube_app_icon-600x600.png">
                  </div>
                </div>
                <img class="d-block img-fluid" src="/static/backgrounds/w2p_backgroundimage02.jpg" alt="First slide">
                <div class="carousel-caption d-none d-md-block">
                  <div class="banner-text">
                      <h2>Manage Your PrintCubes</h2>
                  </div>
                </div>
              </div>
            </div>
		      </div>
	      </div>

        <div class="col-md-4 login-sec">
          <h2 class="text-center btn-marg"> SELECT ACTION </h2>
          <welcome-navigation-link
            :to="$TYPES.ROUTES.SHOPS"
            :text="'MANAGE SHOPS'"
            :iconName="'fa-archive'"
            :buttonName="'btn-default'">
          </welcome-navigation-link>

          <Guard :hideFor="['shop_owner']">
            <welcome-navigation-link
                :to="$TYPES.ROUTES.REGISTRATION+'shop'"
                :text="'REGISTER NEW SHOP'"
                :iconName="'fa-shopping-cart'"
                :buttonName="'btn-info'" />
          </Guard>

          <welcome-navigation-link
            :to="$TYPES.ROUTES.ANALYTICS_SELECT"
            :text="'STATISTICS'"
            :iconName="'fa-signal'"
            :buttonName="'btn-statistics'">
          </welcome-navigation-link>

          <welcome-navigation-link
            :to="$TYPES.ROUTES.DEVICES"
            :text="'DEVICES'"
            :iconName="'fa-align-justify'"
            :buttonName="'btn-success'">
          </welcome-navigation-link>

    		</div>
      </div>
    </div>
</section>
</template>

<script type="text/babel">
import WelcomeNavigationLink from './WelcomeNavigationLink.vue';
import CphIcon from '../../../components/Shared/Icons/Icon';
import ShopPicker from '@/components/Panel/Account/ShopPicker.vue';
export default {
    name: 'WelcomeView',
    components: {
        CphIcon,
        ShopPicker,
        WelcomeNavigationLink
    }
};

</script>

<style lang="scss" scoped>
  @import url("//netdna.bootstrapcdn.com/font-awesome/4.0.3/css/font-awesome.css");
  .login-block{
    background: #39B3D7;  /* fallback for old browsers */
    background: -webkit-linear-gradient(to bottom, #00a5c3, #729fcc);  /* Chrome 10-25, Safari 5.1-6 */
    background: linear-gradient(to bottom, #00a5c3, #729fcc); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
    float:left;
    width:100%;
    padding : 50px 0;
    height: calc(100% - 50px);
  }

  .container{background:#fff; border-radius: 10px; box-shadow:15px 20px 0px rgba(0,0,0,0.1);}
  .carousel-inner{border-radius:10px 0px 0px 10px;}
  .carousel.slide{
    margin-top: 1vh;
    margin-bottom: 1vh;
  }
  .login-sec{
    padding: 50px 30px; position:relative;
  }
  .banner-sec{
    .carousel-caption{
      text-align:left;
      left:5%;
      padding-top: 0px;
      padding-bottom: 0px;
      bottom: 0;
    }
  }
  .login-sec h2{margin-bottom:30px; font-weight:800; font-size:30px; color: #39B3D7;}
  .login-sec h2:after{content:" "; width:100px; height:5px; background:#39B3D7; display:block; margin-top:20px; border-radius:3px; margin-left:auto;margin-right:auto}
  .btn-login{background: #DE6262; color:#fff; font-weight:600;}
  .banner-text{width:70%; position:absolute; bottom:40px; padding-left:20px;}
  .banner-text h2{color:#fff; font-weight:600;}
  .banner-text h2:after{content:" "; width:100px; height:5px; background:#FFF; display:block; margin-top:10px; border-radius:3px;}
  .banner-text p{color:#fff;}


  .logo{
    position: absolute;
    width: 100%;
    top: 10%;

    .logo-container{
      height: 190px;
      width: 180px;
      background:rgba(255, 255, 255, 0.8);
      border-radius: 10px;
      box-shadow:15px 20px 0px rgba(0,0,0,0.1);
      //border: 1px solid #39B3D7;
      margin: 0 auto;
      img{
        width: 180px;
      }
    }
  }

  /**3d buttons **/
</style>
